export const SearchItemV3_With_ID = (searchItem) => {
    const originalMapper = searchItem.mapper;
    searchItem.mapper = (item) => {
        const results = originalMapper(item);
        results.push(item._id);
        return results;
    };
    return searchItem;
};
//# sourceMappingURL=consts.js.map